import { createIcon } from '../create-icon'

// Branching paths — adaptability, multiple styles
export const GpiVersatility = createIcon('GpiVersatility', ({ strokeWidth }) => (
  <>
    <circle cx="18" cy="5" r="3" strokeWidth={strokeWidth} />
    <circle cx="18" cy="19" r="3" strokeWidth={strokeWidth} />
    <circle cx="6" cy="12" r="3" strokeWidth={strokeWidth} />
    <path d="M15.408 6.512a7 7 0 0 0-6.384 3.834" strokeWidth={strokeWidth} />
    <path d="M15.408 17.488a7 7 0 0 1-6.384-3.834" strokeWidth={strokeWidth} />
  </>
))
